import { render, staticRenderFns } from "./create-slot-modal.vue?vue&type=template&id=20076a3c"
import script from "./create-slot-modal.vue?vue&type=script&lang=js"
export * from "./create-slot-modal.vue?vue&type=script&lang=js"
import style0 from "./create-slot-modal.vue?vue&type=style&index=0&id=20076a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports